<template>
<div class="BoxTabellaDettaglio">
    <div class="Counter">
    <!-- Inizio repeater repeater-->
    <div class="RepeaterTabellaDettaglio" v-for="(attivita, index) in this.listaAttivita" :key="index">
        <div class="TabellaDettaglio">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
                <td class="TDRep">
                <div class="TRIndex">
                    <div>Reparto</div>
                    <div>{{ attivita.Reparto }}</div>
                </div>
                </td>
                <td class="TDCom">
                <div class="TRIndex">
                    <div>Comparto</div>
                    <div>{{ attivita.Comparto }}</div>
                </div>
            </td>
            <td class="TDEnt">
                <div class="TRIndex">
                <div>Entità</div>
                <div>{{ attivita.DescrizioneEntita }}</div>
                </div>
            </td>
            <td class="TDAtt">
                <div class="TRIndex">
                <div>Attività</div>
                <div>{{ attivita.DescrizioneAttivita }}</div>
                </div>
            </td>
            <td class="TDNot">
                <div class="TRIndex">
                <div>Note</div>
                <div>
                    {{ attivita.Note }}
                </div>
                </div>
            </td>
            </tr>
        </tbody>
        </table>
    </div>
    </div>
    <!-- Fine repeater repeater-->
</div>
</div>
</template>

<script>

import {apiMixin} from "/mixin.js";
import AttivitaIntervento from "@/models/attivitaIntervento.model.js";

export default {
    name: "GrigliaAttivitaInterventiAssegnati",
    data(){
        return {
            listaAttivita: [],
        }
    },
    mixins:[
        apiMixin
    ],
    props:{
        codiceIntervento: String
    },
    created(){           
        let params = {
            CodiceIntervento: this.codiceIntervento
        };
        this.doApiCall("get", "interventi/GetAttivita", this.$store.getters.getUtente.Token, params).then(

            (data) => {                
                if(data){                                          
                    this.listaAttivita = data.map(o => {
                        return Object.assign(new AttivitaIntervento(), o)
                    });                                  
                }                    
                
            }
        );
    

    }
}
</script>